import Icon from '@/components/snippets/icon/icon'
import { FilterItem } from 'libs/searchspring/components/collection/filters/FilterItem'
import { FilterSelected } from 'libs/searchspring/components/collection/filters/FilterSelected'
import { SortItem } from '@/components/libs/searchspring/components/collection/filters/SortItem'
import { calculateProductCount } from 'libs/searchspring/components/collection/filters/ProductCount'
import { useFilters } from 'libs/searchspring/hooks/useFilters'
import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'
import { useEffect, useRef } from 'preact/hooks'

export function FilterDrawer({ id = 'filters' }) {
  const {
    handleClearFilters,
    handleToggleFilter,
    handleRemoveFilter,
    activeFilters,
    fetchedFilters
  } = useFilters()

  const { results } = useInfiniteScrollResults()
  const totalResults = calculateProductCount(results)
  const drawerRef = useRef(null)

  useEffect(() => {
    const handleOpenFilters = () => {
      const drawer = drawerRef.current
      if (drawer && drawer.dataset.ui !== 'visible') {
        drawer.handleToggle?.()
      }
    }

    window.addEventListener('searchspring:open-filters', handleOpenFilters)
    return () => window.removeEventListener('searchspring:open-filters', handleOpenFilters)
  }, [])

  return (
    <x-modal
      ref={drawerRef}
      className="group/filters z-60"
      data-id={id}
      data-body-lock
    >
      <div className="flex flex-col lg-max:justify-end fixed inset-bl w-full h-view p-margin pointer-events-none group-data-visible/filters:pointer-events-auto z-60 transition-all">
        <div className="flex flex-col size-full lg:max-w-[476px] lg-max:max-h-[85%] bg-secondary lg:-translate-x-full-margin group-data-visible/filters:lg:translate-x-0 lg-max:translate-y-full-margin group-data-visible/filters:lg-max:translate-y-0 z-2 transition-all">
          <div class="shrink-0 flex flex-col">
            <div className="flex gap-x-gutter items-center justify-between w-full h-[60px] pl-1 md:pl-1.5 pr-0.625 md:pr-1 border-b border-neutral-medium">
              <h2 className="h5 font-semibold">Filters & Sort</h2>
              <button
                className="btn btn-primary btn-text btn-square w-[44px] link-fade"
                data-modal-parent={id}
                data-modal-role="close"
                aria-label="Close Filters"
              >
                <div className="flex size-[12px] children:size-full">
                  <Icon id="close" />
                </div>
              </button>
            </div>
            <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
          </div>
          <div className="grow flex flex-col overflow-y-scroll no-scrollbar overscroll-none">
            <SortItem />
            {fetchedFilters.length > 0 ? (
              fetchedFilters.map((filter) => (
                <FilterItem
                  filter={filter}
                  onFilter={handleToggleFilter}
                  fetchedFilters={fetchedFilters}
                  activeFilters={activeFilters}
                  key={filter.field}
                />
              ))
            ) : (
              <p className="px-1 md:px-1.5 py-1 text-neutral-secondary">No filters available</p>
            )}
          </div>
          <div className="shrink-0 flex gap-x-gutter w-full px-1 md:px-1.5 py-1.5 border-t border-neutral-medium">
            {activeFilters.size > 0 && (
              <button
              className="btn btn-primary btn-border btn-m"
              onClick={handleClearFilters}
              aria-label="Clear Filters"
            >
              Clear All
            </button>
            )}
            <button
              className="grow btn btn-primary btn-fill btn-m"
              data-modal-parent={id}
              data-modal-role="close"
              aria-label="View Results"
            >
              View {totalResults} Result{totalResults !== 1 ? 's' : ''}
            </button>
          </div>
        </div>
        <button
            className="fixed inset-tl size-full bg-neutral-black/60 backdrop-blur-sm opacity-0 group-data-visible/filters:opacity-100 pointer-events-none group-data-visible/filters:pointer-events-auto cursor-w-resize transition-all"
            data-modal-parent={id}
            data-modal-role="close"
            aria-label="Close Filters"
          >
          </button>
      </div>
    </x-modal>
  )
}
